import { makeStyles } from '@material-ui/core';
import Colors from '../Colors';

export const useStyles = makeStyles((theme) => ({
  rootFragment: {
    '& > *': {
      border: 'none',
    },
    position: 'absolute',
  },
  headCollapse: {
    fontSize: '15px',
    fontWeight: 'bolder',
    color: '#fff',
    borderBottom: 'none',
  },
  rowCollapse: {
    backgroundColor: Colors.secundary,
  },
  root: {
    width: '70%',
    alignSelf: 'center',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  table: {
    minWidth: 700,
    backgroundColor: Colors.secundary,
    border: '0.5px solid rgba(0, 0, 0, 0.5)',
    borderRadius: '0px',
    [theme.breakpoints.down('sm')]: {
      width: '120%',
      overflow: 'scroll',
    },
  },
  tableCellHead: {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    color: Colors.tertiary,
    border: '0.5px solid rgba(0, 0, 0, 0.2)',
    fontVariant: 'small-caps',
  },
  tableRow: {
    backgroundColor: '#fff',
    border: 'none',
    borderRadius: '0px',
  },
  tableCellBody: {
    backgroundColor: '#fff',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    color: '#000000',
    border: '0.5px solid rgba(0, 0, 0, 0.2)',
  },
  damageForm: {
    width: '100%',
    padding: '1rem 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1px solid #808080',
  },
}));
